module.exports = __webpack_public_path__ + "static/media/Pontem.5476659c.png";